import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../actionTypes';

const initialState = false;

const isRebranding = () => true;
const isEnding = () => false;

export default createReducer(initialState, {
  [actionTypes.REBRAND_REQUEST]: isRebranding,
  [actionTypes.REBRAND_SUCCESS]: isEnding,
  [actionTypes.REBRAND_FAILURE]: isEnding,
});
